import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ENDPOINTS, API_BASE_DOCS } from "../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const Register = () => {
  const [formData, setFormData] = useState({
    IdDocumento: "",
    type_doc: "",
    first_name: "",
    second_name: "",
    last_name: "",
    second_last_name: "",
    email: "",
    password_hash: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [acceptDataPolicy, setAcceptDataPolicy] = useState(false);


  const navigate = useNavigate();


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!acceptDataPolicy) {
    setError("Debe aceptar el tratamiento de datos personales para continuar.");
    return;
  }

    try {
      const res = await fetch(ENDPOINTS.ExternalUser, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!data.success) {
        setError(data.message);
        return;
      }

      setSuccess("Usuario registrado correctamente. Redirigiendo...");
      setTimeout(() => navigate("/login"), 2000);

    } catch (err) {
      console.error(err);
      setError("Error en el servidor");
    }
  };

  return (
    <div className="container pt-5 mt-5 mb-5" style={{ maxWidth: "700px" }}>
      <form className="card p-4 shadow-sm" onSubmit={handleRegister}>

        <h3 className="text-center mb-3">Crear cuenta nueva</h3>
        <h6 className="text-center text-secondary mb-3">Es rápido y fácil</h6>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* DOCUMENTO */}
        <div className="mb-3">
          <label>Documento *</label>
          <input
            type="text"
            name="IdDocumento"
            className="form-control"
            value={formData.IdDocumento}
            onChange={handleChange}
          />
        </div>

        {/* TIPO DE DOCUMENTO */}
        <div className="mb-3">
          <label>Tipo de documento *</label>
          <select
            name="type_doc"
            className="form-select"
            value={formData.type_doc}
            onChange={handleChange}
          >
            <option value="" hidden>Selecciona...</option>
            <option value="CC">Cédula de ciudadanía</option>
            <option value="TI">Tarjeta de identidad</option>
            <option value="PPT">PPT</option>
            <option value="CE">Cédula de extranjería</option>
          </select>
        </div>

        {/* NOMBRES */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Primer nombre *</label>
            <input
              type="text"
              name="first_name"
              className="form-control"
              value={formData.first_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Segundo nombre</label>
            <input
              type="text"
              name="second_name"
              className="form-control"
              value={formData.second_name}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* APELLIDOS */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Primer apellido *</label>
            <input
              type="text"
              name="last_name"
              className="form-control"
              value={formData.last_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Segundo apellido</label>
            <input
              type="text"
              name="second_last_name"
              className="form-control"
              value={formData.second_last_name}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* CORREO */}
        <div className="mb-3">
          <label>Correo electrónico</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {/* CONTRASEÑA */}
        <div className="mb-3">
          <label>Contraseña *</label>
          <input
            type="password"
            name="password_hash"
            className="form-control"
            value={formData.password_hash}
            onChange={handleChange}
          />
        </div>

        {/* TRATAMIENTO DE DATOS */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="dataPolicy"
            checked={acceptDataPolicy}
            onChange={(e) => setAcceptDataPolicy(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="dataPolicy">
            Acepto el tratamiento de datos personales conforme a la{" "}
            <a href={`${API_BASE_DOCS}/uploads/documentos_internos/TRATAMIENTO_DATOS_PERSONALES.pdf`} target="_blank" rel="noopener noreferrer">
              Política de Privacidad
            </a>.
          </label>

          
        </div>


        <button type="submit" className="btn btn-outline-pink w-100">
          Crear cuenta
        </button>

        <div className="mt-3">
            <button type="button" className="btn btn-outline-purple w-100" onClick={() => navigate("/login")}>
            Volver al inicio de sesión
            </button>
        </div>

      </form>
    </div>
  );
};

export default Register;
